"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var styles_1 = require("@material-ui/core/styles");
var useTableTagStyles = styles_1.makeStyles(function (theme) {
    return styles_1.createStyles({
        root: {
            fontWeight: 400,
            fontSize: '14px',
            background: theme.palette.secondary.main,
            '&:hover': {
                background: theme.palette.secondary.dark,
            },
            borderRadius: '5px',
            display: 'inline',
            marginRight: theme.spacing(0.5),
            paddingRight: theme.spacing(1),
            paddingLeft: theme.spacing(1),
            minWidth: 0,
            minHeight: 0,
            color: 'white',
        },
    });
});
function TableTag(_a) {
    var tag = _a.tag, onClick = _a.onClick;
    var classes = useTableTagStyles();
    return (react_1.default.createElement(core_1.Button, { variant: "contained", size: "small", className: classes.root, onClick: function (e) {
            e.stopPropagation();
            onClick();
        }, disableRipple: true }, tag));
}
exports.default = TableTag;
